$(function () {
    if (!($("div[id^='ppcarto']").length) && !($("div[class^='ppcarto']").length)) {
        return;
    }

    const enableCSS = () => {
        $('#ppcarto-css').removeAttr('disabled');
    };

    const getCachedScript = (url, options) => {

        // Allow user to set any option except for dataType, cache, and url
        options = $.extend(options || {}, {
            dataType: "script",
            cache: true,
            url: url
        });
        // Use $.ajax() since it is more flexible than $.getScript
        // Return the jqXHR object so we can chain callbacks
        return $.ajax(options);
    };

    // ******* helper function to load a script ***************
    const loadScript = (src) => {
        const isLoaded = $.Deferred();
        getCachedScript(src)
            .done(() => {
                if (isLoaded.state() == "pending") {
                    isLoaded.resolve();
                }
            })
            .fail((jqxhr, settings, exception) => {
                if (isLoaded.state() == "pending") {
                    isLoaded.reject(exception);
                }
            });
        if ($(`script[data-cmp-src^='${src}']`).length > 0) {
            isLoaded.resolve();
        }
        return isLoaded.promise();
    }

    const vueLoaded = () => {
        let timer = 0;
        const isLoaded = $.Deferred();
        let checker = setInterval(() => {
            timer++;
            if (!!window.Vue) {
                clearInterval(checker);
                isLoaded.resolve();
            } else if (timer > 100) {
                clearInterval(checker);
                isLoaded.reject();
            }
        }, 50);
        return isLoaded.promise();
    };
    // ********************************************************

    var ppcartoLoaded = $.Deferred();

    // load from the same map build as the #ppcarto-css stylesheet
    var scriptRoot = `${$('meta[name="ppcarto-root"]').attr('content')}js`;
    //var scriptRoot = `https://localhost:3002/js`;
    //*
    if (window.location.href.indexOf("localhost") > -1) {
        scriptRoot = `https://localhost:3003/js`;
        //scriptRoot = `${window.pixelpoint.map.root()}test/js`;
        //scriptRoot = `https://10.0.0.129:3003/js`;
    } else if (window.location.href.indexOf("192.168.1.105") > -1) {
        scriptRoot = `https://192.168.1.105:3003/js`;
        //scriptRoot = `https://10.0.0.129:3003/js`;
    } else if (window.location.href.indexOf("10.0.0.129") > -1) {
        scriptRoot = `https://10.0.0.129:3003/js`;
        //scriptRoot = `https://10.0.0.129:3003/js`;
    }
//*/

    var initialize = () => {
        var librariesToLoad = null;
        var scriptsToLoad = [];

        if ($("#ppcarto").length > 0 || $("#ppcarto-medium").length > 0) {
            librariesToLoad = `${scriptRoot}/ppcarto.light.lib-min.js`;
            scriptsToLoad.push(`${scriptRoot}/ppcarto.small_medium-min.js`);
        }
        if ($("#ppcarto-airbnb").length > 0 || $(".ppcarto-airbnb").length > 0) {
            librariesToLoad = `${scriptRoot}/ppcarto.medium.lib-min.js`;
            scriptsToLoad.push(`${scriptRoot}/ppcarto.airbnb-min.js`);
        }
        if ($("#ppcarto-static").length > 0 || $(".ppcarto-static").length > 0) {
            librariesToLoad = `${scriptRoot}/ppcarto.medium.lib-min.js`;
            scriptsToLoad.push(`${scriptRoot}/ppcarto.static-min.js`);
        }
        if (!!librariesToLoad) {
            //*
            loadScript(librariesToLoad)
                .done(function () {
                    enableCSS();
                    var defers = [];
                    vueLoaded().done(() => {
                        $.each(scriptsToLoad, function (i, script) {
                            defers.push(loadScript(script));
                        });
                        $.when.apply($, defers).then(function () {
                            window.ppcartoScriptsLoaded = true;
                            ppcartoLoaded.resolve();
                        })
                    })
                        .fail(() => {
                            console.log("Error while checking for vue");
                        });
                })
                .fail(function (jqxhr, settings, exception) {
                    console.log("error while loading");
                });
            //*/
        }
    }

    // ✅ Always wait 5 seconds before executing initialize (debounced)
    const INITIALIZE_DELAY_MS = 2000;
    let initializeTimeoutId = null;

    const initializeDelayed = () => {
        if (initializeTimeoutId) clearTimeout(initializeTimeoutId);
        initializeTimeoutId = setTimeout(() => {
            initializeTimeoutId = null;
            initialize();
        }, INITIALIZE_DELAY_MS);
    };

    if (typeof __cmp !== 'undefined' && !!__cmp) {
        __cmp("addEventListener", ["consent", () => {
            initializeDelayed();
        }, true], null)
    }else{
        initializeDelayed();
    }

    initializeDelayed();

    window.pixelpoint.map.async = {
        checkMedium: function () {
            var defer = $.Deferred();
            if (!!window.pixelpoint.map.promises && !!window.pixelpoint.map.promises.mediumMapLoaded && window.pixelpoint.map.promises.mediumMapLoaded.state() == "resolved") {
                defer.resolve();
            } else {
                var newScriptToLoad = "";
                var newLibrariesToLoad = "";
                if ($("#ppcarto").length > 0 || $("#ppcarto-medium").length > 0) {
                    newLibrariesToLoad = `${scriptRoot}/ppcarto.light.lib-min.js`;
                    newScriptToLoad = `${scriptRoot}/ppcarto.small_medium-min.js`;
                    if (!!newLibrariesToLoad) {
                        getCachedScript(newLibrariesToLoad)
                            .done(function () {
                                getCachedScript(newScriptToLoad).done(function () {
                                    defer.resolve();
                                }).fail(function () {
                                    defer.reject();
                                });
                            })
                            .fail(function (jqxhr, settings, exception) {
                                console.log("error while loading");
                                defer.reject();
                            });
                    }
                }
            }
            return defer.promise();
        }
    };

    window.pixelpoint.map.scriptsLoaded = function (callback) {

        //console.log("callback added to scriptsLoaded");
        $.when(ppcartoLoaded).then(function () {
            vueLoaded().done(() => {
                callback();
            }).fail(() => {
                console.log("error calling callback");
            });
        });
    }
});
